export class ResizeElem {
    constructor() {
        this.toggleMenus = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };

    init() {
        // 環境
        //this.env = new Env();
        //this.env.detectEnv();
    }

    beforeresizing() {

    }

    resizing() {
        let nowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let nowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        this.body = document.getElementsByTagName('body')[0];
        let windowWidthChanged = false;
        let windowHeightChanged = false;


        //ウインドウ幅が変わった場合のみ実行したい
        if (this.body.classList.contains('os-ios') || this.body.classList.contains('os-android')) {
            //モバイルは幅のみで判定、高さはスクロール時にURLバーの大きさが変わる
            if (this.windowWidth !== nowWidth) {
                windowWidthChanged = true;
                console.log('window width changed mobile');
            }
        } else {
            //PC高さも
            if (this.windowWidth !== nowWidth || this.windowWeight !== nowHeight) {
                windowWidthChanged = true;
                console.log('window width changed PC');
            }
        }
        if (this.windowHeight !== nowHeight) {
            windowHeightChanged = true;
            //iOSではスクロール時に高さが変わる（ツールバーのサイズ変更など）
        }


        if (windowWidthChanged) {
            if (document.querySelectorAll('.js-resize-index-cover')[0]) {
                let elems = document.querySelectorAll('.js-resize-index-cover');

                // ツールバーを除いた高さを計算
                //let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
                let windowHeight = (document.documentElement.clientHeight || 0);
                let vh = windowHeight;
                if (vh < 500) {
                    vh = 500;
                }

                console.log('clientHeight: ', document.documentElement.clientHeight);
                console.log('innerHeight: ', window.innerHeight);
                //window.alert('clientHeight: ' + document.documentElement.clientHeight + ', innerHeight: ' + window.innerHeight);

                //chromeのスマホエミュレーションではwindow.innerHeightがずれる場合あり
                let props = {
                    'vh': vh,
                }

                //this.setProps(elem, props);
                for (let i = 0; i < elems.length; i++) {
                    this.setProps(elems[i], props);
                }
                //console.log('resize:' + vh);
            }

            this.windowWidth = nowWidth;
            this.windowWeight = nowHeight;
        }
    }

}